import ADD_CAMPER_TRIP_TO_CART from "../../graphql/mutations/addCamperTripToCart";
import {useMutation} from "@apollo/react-hooks";
import {getSessionId} from "../../services/session";
import React, {useState} from "react";
import {Button, Modal, ModalFooter} from "reactstrap";
import Link from "next/link";
import ModalHeader from "../Modal/ModalHeader";

const AddCamperToCartButtonMobile = ({
                                         camperSeoId,
                                         pickupDate,
                                         dropOffDate,
                                         pickupLocation,
                                         dropOffLocation,
                                         insuranceOptions,
                                         options
}) => {
    const [addCamperTripToCart] = useMutation(ADD_CAMPER_TRIP_TO_CART);
    const uuid = getSessionId();
    const [modal, setModal] = useState(false);
    const toggle = () => setModal(!modal);

    return (
        <>
            <Button
                onClick={() => {
                    addCamperTripToCart({
                        variables: {
                            uuid: uuid,
                            pickupDate: pickupDate.format('YYYY-MM-DD'),
                            dropOffDate: dropOffDate.format('YYYY-MM-DD'),
                            camperSeoId: camperSeoId,
                            pickupLocation: pickupLocation,
                            dropOffLocation: dropOffLocation,
                            insuranceOption: insuranceOptions,
                            options: options
                        }
                    })
                    toggle();
                }
                }
                size="sm"
                aria-label="Boek camper"
                className="book-button"
                color="primary"
                block
            >
                Voeg toe aan winkelwagen
                {" "}
                <i className="fas fa-shopping-cart"/>
            </Button>
            <Modal isOpen={modal} toggle={toggle} centered={true} fade={false} backdropClassName="desktop-backdrop" contentClassName="modal-border">
                <ModalHeader toggle={toggle}>
                    <h6>De camper is toegevoegd aan uw winkelwagen</h6>
                </ModalHeader>
                <ModalFooter>
                    <Button color="secondary" onClick={toggle}>Verder winkelen</Button>
                    {' '}
                    <Link href="/winkelwagen">
                        <Button color="primary" onClick={toggle}>Naar winkelwagen</Button>
                    </Link>
                </ModalFooter>
            </Modal>
        </>
    )
}

export default AddCamperToCartButtonMobile;
